<template>
  <!-- Importing Forgot Password Component -->
  <ForgotUsernameComp></ForgotUsernameComp>
</template>
<script>
import ForgotUsernameComp from "../../components/Auths/ForgotUsername.vue";

export default {
  name: "Username Forgot",
  components: { ForgotUsernameComp },
  computed: {},
  mounted() {},
};
</script>
